import React from 'react';
import ScrollContainer from '../../../BaseModule/Components/ScrollContainer/ScrollContainer';
import FlatList from '../../../BaseModule/Components/FlatList/FlatList';
import useFlatData from '../../../BaseModule/Hooks/useFlatData';
import useWorkplaces from '../../Hooks/useWorkplaces';
import WorkplaceSelectionItem from './WorkplaceSelectionItem';
import WorkplaceSelectionFilter from './WorkplaceSelectionFilter';
// @ts-ignore
import styles from './WorkplaceSelection.module.scss';
import { get } from '../../../../Services/NetteApiClient';

interface Props {
	linkSelect: string;
}

const WRAPPER_ID = 'workplaceSelectionWrapper';

const WorkplaceSelection: React.FC<Props> = ({ linkSelect }) => {
	const { getFlatWorkplaces, getNextPage, data, isLoading, page, setPage } = useWorkplaces();
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatWorkplaces,
		{
			data: data?.workplaces?.data,
			totalPages: data?.workplaces?.meta?.totalPages,
			page: data?.workplaces?.meta?.page,
		},
		page,
		setPage,
	);

	const handleSelectWorkplace = async (workplaceId: string) => {
		const ajaxLink = linkSelect.replace('=null', '=' + workplaceId);
		await get(ajaxLink);
	};

	return (
		<div className={styles.wrapper}>
			<WorkplaceSelectionFilter onFilter={setFilter} />
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList onRefresh={loadData}
									onLoadMore={getNextPage}
									data={flatData}
									isLoading={isLoading}
									className={styles.flatWrapper}
									hasMoreData={hasMoreData} scrollableTargetId={WRAPPER_ID}
									renderItem={(item) => <WorkplaceSelectionItem onSelect={handleSelectWorkplace} item={item} />}
				/>
			</ScrollContainer>
		</div>
	);
};

export default WorkplaceSelection;